import angular from 'angular';

export default angular.module('app.controllers', []).name;
